const webPropsToSkip = {};
export { webPropsToSkip };
//# sourceMappingURL=webPropsToSkip.mjs.map
